export default __webpack_public_path__ + "static/webRotator/svg/117bf71d53c5805a3275ca13a034ab50.svg";